<script>
import { language } from './stores.js';
import { isMobile } from './stores.js';
console.log("isMobile in home")
console.log(isMobile)
let isItInMobile;
isMobile.subscribe(value => {
		isItInMobile = value;
	});
console.log(isItInMobile)
</script>
<div id="home-body">

<img class:mobiimg="{isItInMobile === true}" src="images/lands.jpeg" alt="background image" />
<!-- <img class:mobiimg="{isItInMobile === true}" src="https://payload.cargocollective.com/1/3/120972/14346409/Fyring_composite_cropped_1000.jpg" alt="---img---"> -->

<!-- {#if isItInMobile == true}

<img class:mobiimg="{isItInMobile === true}" src="images/portr.jpeg" alt="background image" />
{:else}
<img class:mobiimg="{isItInMobile === true}" src="images/lands.jpeg" alt="background image" />
{/if} -->
<div id="text" class:mobitext="{isItInMobile === true}" class:nonmobitext="{isItInMobile === false}" >

{#if $language == 0}

<p>
Kryddbrännvinet Fyring har sitt ursprung i ett 1700-talsrecept,
varsamt tolkat och moderniserat av konstnären och krögaren Stig Fyring (1934-2015).
År 2022 har Stigs familj åter börjat krydda snapsen Fyring och nu
går den att beställa på Systembolaget, samt till maten på klassiska
Stockholmskrogar som Tennstopet och Pelikan.
<p>
<a href="https://www.systembolaget.se/produkt/sprit/fyring-5474202/"> Kolla in snapsen på Systembolaget!
</a>
</p>

<br>
<hr style="width:75%;text-align:center;opacity:50%">
<br>

<em>
<p>
Fyring Kryddbrännvin is a Swedish aquavit or spice brandy
conceived by the artist Stig Fyring (1934-2015), based on a recipe from
the 18th century. In 2022 Fyring Kryddbrännving has been reintroduced
by Stig's children, grand children, and family and it is now available
through Systembolaget and at classic Stockholm venues such as Tennstopet and Pelikan.
<p>
<a href="https://www.systembolaget.se/produkt/sprit/fyring-5474202/">Take me over to Systembolaget!
</a>
</p>
</em>

<div id="iconbar">
</div>

{/if}
</div>
</div>


<style>
	img{
		display: inline-block;
		height:500px;
		border-top:0;
	}
	#home-body{
		width:100%;
		text-align: center;

	}
	#text{
		display: inline-block;
		margin-left:15px;
		vertical-align:top;
	}
	.mobitext{
		width: 70%;
		margin-top:21px;
	}
	.nonmobitext{
		width: 25%;
		margin-top:0px;
	}
	.mobiimg{
		width: 70%;
		height:20%;
		margin-top:21px;
		content: url("/images/portr.jpeg");
	}
	p{
		text-align: left;
		font-size: 13px;
	}
	a{
		text-align: left;
		font-size: 13px;
	}
</style>
